import Swal from 'sweetalert2';
var bootstrap;

export default {
  /**
   * You must provide a bootstrap module here
   * @param {*} app App instance provided by Vue's use() function
   * @param {*} bs Bootstrap instance (global instance for your app).
   * @param {*} options
   */
  install: (app, bs) => {
    bootstrap = bs;
    // cheap hack to tell us whether we are using vue2 or vue3
    if ('globalProperties' in app.config) {
      // vue3 injection
      app.config.globalProperties.$swal = Swal;
    } else {
      // vue2 injection
      app.prototype.$swal = Swal;
    }
  },
};

export { bootstrap };
